/**
 * FASE 2 — Campo da DATA DA GRADUAÇÃO ("faixa atual desde").
 *
 * Três coisas na tela, nesta ordem:
 *   1. o campo de data (opcional);
 *   2. a linha de retorno: há quanto tempo o atleta está na faixa, ou o AVISO
 *      de incoerência (data no futuro, antes do início no Jiu-Jitsu, antes do
 *      nascimento) — sempre aviso, nunca bloqueio;
 *   3. quando a FAIXA foi trocada no formulário, a pergunta: "usar hoje?" —
 *      com um clique. O sistema NUNCA muda a data sozinho.
 *
 * Não existe grau neste campo (decisão do usuário: grau varia demais de equipe
 * para equipe) e o sistema não decide quem está pronto para graduar.
 */
import { Input } from './ui/input';
import { Label } from './ui/label';
import { AlertTriangle, CalendarClock } from 'lucide-react';
import { hojeIso, formatarDataBr, resumoDataGraduacao, tempoNaFaixa } from '../lib/graduacao';

export default function CampoDataGraduacao({
  value,
  onChange,
  belt = '',
  beltOriginal = '',
  startDate = '',
  birthDate = '',
  label = 'Faixa atual desde',
  testId = 'belt-since',
  className = '',
}) {
  const resumo = resumoDataGraduacao(value, { startDate, birthDate });
  const faixaMudou = Boolean(beltOriginal && belt && belt !== beltOriginal);
  const hoje = hojeIso();

  return (
    <div className="space-y-1.5">
      {label && <Label className="text-[#A1A1AA] text-xs">{label}</Label>}

      <Input
        type="date"
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        data-testid={testId}
        aria-invalid={resumo.tipo === 'aviso' ? 'true' : 'false'}
        className={`bg-[#1A1A1A] border-[#27272A] text-white ${
          resumo.tipo === 'aviso' ? 'border-amber-500/60' : ''
        } ${className}`}
      />

      <p
        data-testid={`${testId}-resumo`}
        className={`text-micro leading-tight flex items-center gap-1 ${
          resumo.tipo === 'aviso' ? 'text-amber-400' : 'text-[#71717A]'
        }`}
      >
        {resumo.tipo === 'aviso'
          ? <AlertTriangle className="w-3 h-3 shrink-0" />
          : resumo.tipo === 'ok' ? <CalendarClock className="w-3 h-3 shrink-0" /> : null}
        {resumo.texto}
      </p>

      {/* Faixa trocada no formulário: PERGUNTA, nunca muda sozinho. */}
      {faixaMudou && (
        <p className="text-micro text-amber-400 leading-tight" data-testid={`${testId}-troca`}>
          Faixa alterada de <strong>{beltOriginal}</strong> para <strong>{belt}</strong>.{' '}
          <button
            type="button"
            onClick={() => onChange(hoje)}
            data-testid={`${testId}-usar-hoje`}
            className="underline text-[#D4AF37] hover:text-white"
          >
            {value ? 'Usar hoje' : 'A nova faixa começou hoje'} ({formatarDataBr(hoje)})
          </button>
        </p>
      )}

      {!faixaMudou && resumo.tipo === 'ok' && (
        <p className="text-micro text-[#71717A] leading-tight">
          Opcional. Use quando o atleta recebeu a faixa que tem hoje
          {tempoNaFaixa(value, hoje) ? ` (${tempoNaFaixa(value, hoje)})` : ''}.
        </p>
      )}
    </div>
  );
}
